import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AppConfig {
  private config: object = null;

  constructor(private http: HttpClient) {}

  public getConfig(key: any): any {
    return this.config[key];
  }

  public load(): Promise<any> {
    return new Promise(resolve => {
      this.http
        .get('assets/configuration.json')
        .pipe(
          map(res => res),
          catchError((error: any): any => {
            console.log('Configuration file "configuration.json" could not be read.');
            resolve(true);
            return observableThrowError(error.json().error || 'Server error');
          })
        )
        .subscribe((response: object) => {
          this.config = response;
          resolve(true);
        });
    });
  }
}
